export const TRANSFORM_PRODUCT_IMAGE_BACKGROUND = true;

